import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private title: Title, private meta: Meta) {
    this.title.setTitle('Mobile-Login - Conventional Parallel Rook')
    this.meta.addTags([
      {
        property: 'og:title',
        content: 'Mobile-Login - Conventional Parallel Rook',
      },
    ])
  }

  ngOnInit() {
  }

}
